import {Component, Input} from '@angular/core';
import {AbstractComponent, ConfirmationCanvasComponent} from "@components";
import {MEASUREMENTS_LIST, TIMER_SCREEN} from "../../../../app-routing.module";
import {Router} from "@angular/router";
import {EventItem, Lookups, Waypoint, WaypointType} from "@model";
import {MeasurementTimeItemHolderService} from "@services";
import {TranslocoService} from "@ngneat/transloco";
import {NgbOffcanvas} from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: 'app-timing',
  templateUrl: './timing.component.html',
  styleUrls: ['./timing.component.scss']
})
export class TimingComponent extends AbstractComponent {

  @Input() event?: EventItem;
  @Input('timingWaypointList') waypoints?: Waypoint[] = [];
  @Input({required: true}) languages: Lookups[] = [];

  constructor(
      private router: Router, private offcanvasService: NgbOffcanvas, private measurementTimeItemHolderService: MeasurementTimeItemHolderService, private translocoService: TranslocoService
  ) {
    super();
  }

  ngOnInit() {
  }

  goToTimer(waypoint: Waypoint): void {
    if (waypoint.waypointTypeId !== WaypointType.START_WAYPOINT) {
      this.router.navigate([TIMER_SCREEN],
          {queryParams: {waypointId: waypoint.id},
            queryParamsHandling: "merge",
            replaceUrl: true});
    }
  }


  back(): void {
    this.router.navigate([MEASUREMENTS_LIST]);
  }

  deleteCache() {
    const offcanvasRef = this.offcanvasService.open(ConfirmationCanvasComponent, {
      position: 'bottom',
      scroll: false,
      panelClass: 'confirmation-canvas',
    });

    offcanvasRef.componentInstance.title = this.translocoService.translate("timing.clear.cache.confirmation.title");
    offcanvasRef.componentInstance.text = this.translocoService.translate("timing.clear.cache.confirmation.text");

    offcanvasRef.componentInstance.onConfirm.subscribe(() => {
      this.measurementTimeItemHolderService.deleteAllEventHolders();
      this.offcanvasService.dismiss();
    });
  }

  protected readonly WaypointType = WaypointType;

}
